@import '../../style/index';

:host {
  display: block;
  background-color: var(--colors-basic-white);
  position: absolute;
  z-index: 299;

  .action-call {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin: var(--spacings-l) 0;
  }

  .list {
    padding-bottom: var(--spacings-xxl);

    &__item {
      border-bottom: 2px solid var(--colors-grey-medium);
      padding: var(--spacings-m) 0;
      cursor: pointer;

      p {
        @include headline-3();

        font-family: $font-family-regular;
        margin: 0;
      }

      .description {
        font-size: rem-calc(16px);
        line-height: rem-calc(24px);

        @include medium-up {
          @include headline-3();

          font-family: $font-family-regular;
          margin: 0;
        }
      }
    }

    rcm-button {
      margin: var(--spacings-l) auto;
    }
  }

  .results {
    &__container {
      margin-top: var(--spacings-l);

      @include xlarge-up() {
        margin-top: var(--spacings-xl);
      }
    }
  }

  .legend {
    border-bottom: 2px solid var(--colors-dark-base);
    display: flex;
    justify-content: space-between;

    &-text {
      margin-top: 0;
      margin-bottom: rem-calc(8px);
    }

    &-link {
      @include headline-3();

      text-decoration: underline;
      cursor: pointer;
      float: right;
    }
  }

  .error-message {
    color: var(--colors-grey-dark);
    margin-top: var(--spacings-l);
  }
}
